import QR from "./QR-code";
import date from "../helper/globalFunctions";


export default class Print {
  constructor(data,SRC) {
    this.print(data,SRC);
  }

  html = async (data,SRC, qr) => {
    return new Promise((resolve, reject) => {
      const html = `<!DOCTYPE html>
      <html lang="en">
      <head>
          <style>.container {
              width: 600px; /* Adjust width as needed */
              border: 1px solid black;
              margin: 0 auto;
              padding: 1rem;
              display: flex;
              flex-direction: column;
              font-family: sans-serif;
          }
          
          .header,
          .content,
          .barcode-section,
          .footer {
              padding: 0.5rem;
              border-bottom: 1px solid lightgray;
          }
          
          .header {
              text-align: center; /* Change for logo placement */
          }
          
          .content {
              display: flex;
              flex-direction: row;
          }
          
          .left-section,
          .right-section {
              flex: 1;
          }
          
          .left-section h2,
          .right-section h2 {
              margin-bottom: 0.5rem;
          }
          
          .barcode-section {
              text-align: center;
          }
          
          .barcode-section img {
              width: 100%; /* Adjust image width as needed */
          }
          
          .footer {
              text-align: center;
          }
          </style>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>package:${data.id}</title> 
      </head>
      <body>
          <div class="container">
              <div class="header">
              <p class="left-section">  Print at :  ${new Date().toLocaleString()} by quickdeliverysystem.com</p>
             
                  </div>
                  <div class="content">
                  <div class="left-section">
                  <h2>SHIP TO</h2>
                      <b>${data.dest_name}</b>
                      <p>${data.dest_address} </p>
                      <p> ID : ${data.id}  </p>
                     
                     
                  </div>
                  <div class="right-section">
                  <h2>Track package</h2>
                  <img   style=" text-align:center; width:160px;height:160px" src="${qr["track"]}">
                  </div>
              </div>
              <div class="content">
              <div class="left-section">
              <h2>SENDER</h2>
                  <b>${data.sender_name}</b>
                  <p>${data.sender_address} </p> 
                   <p>  Date at:  ${date.subStringDate(data.created_at)}</p>
                 
              </div>
              <div class="right-section">
                  <h2>PROCESS</h2>
                  <b>${SRC.name}</b>
                  <p>${SRC.address}</p>
                  <p>Id:${SRC.id} </p> 
              </div>
          </div>
              <div class="barcode-section">
              <img style=" text-align:center; width:250px;height:110px" src="${qr["barcode"]}">
            
              </div>
              
          </div>
      </body>
      </html>
      
      `;
      resolve(html);
    });
  };

  print = async (data,SRC) => {
    const qc = new QR();
    (async () => {
      var q = {};

      // q.package = await qc.qrBuild(`${data.id}`);

      q.track = await qc.qrBuild(
        `https://track.quickdeliverysystem.com/?uuid=${data.uuid}`
      );



       q.barcode=await qc.barBuild(data.id)
 
      // q.app = await qc.qrBuild("https://pexcode.com/app");

      var newWin = window.frames["printf"];
      await this.html(data,SRC, q).then((res) => {
        newWin.document.write(res);
        newWin.document.close();
      });
      newWin.print({ silent: true });
    })();
  };
}
